import React, { useEffect, useState } from "react";
import WorkingPartDetailTimeline from "./workingPartDetail.timeline.view";
import * as WorkingPartService from "../../../../services/WorkingPartServices";

const WorkingPartDetailContainer = ({ uuid }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (uuid) {
      WorkingPartService.getWorkingPartByUuid(uuid).then((result) => {

        setData(result);
      });
    }
  }, [uuid]);

  const handleUpdateDays = async (nifSociety, days) => {
    if (uuid) {
      const result = await WorkingPartService.updateDaysBySociety(
        uuid,
        nifSociety,
        days
      );

      if (result) {

        WorkingPartService.getWorkingPartByUuid(uuid).then((updatedResult) => {
          setData(updatedResult);
        });
      }
      return result;
    }
    return null;
  };

  return (
    <WorkingPartDetailTimeline
      data={data}
      uuid={uuid}
      onUpdateDays={handleUpdateDays}
    />
  );
};

WorkingPartDetailContainer.propTypes = {};

export default WorkingPartDetailContainer;
